module.exports = __webpack_public_path__ + "static/three-6c2fe15fa8c4df4f7481740eccd85210.svg";